export interface IPointConfig {
  radius: number;
  color: string;
  textColor?: string;
  borderColor?: string;
  borderWidth?: number;
  count?: string;
  hasContourShadow: boolean;
}

export function getPointConfig(): IPointConfig {
  return {
    radius: 1,
    color: 'rgba(0,0,0,0)',
    textColor: 'rgba(0,0,0,0)',
    borderColor: 'rgba(0,0,0,0)',
    borderWidth: 1,
    count: '0',
    hasContourShadow: false,
  };
}
